import { Component } from '@angular/core';

@Component({
  // tslint:disable-next-line
  selector: 'body',
  template: '<ng-progress></ng-progress><router-outlet></router-outlet>'
})
export class AppComponent { }



// WEBPACK FOOTER //
// /app/src/app/app.component.ts